"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryBooleanSchema = void 0;
const zod_1 = require("zod");
/**
 * Cờ bật/tắt đi qua chuỗi truy vấn URL.
 *
 * **KHÔNG dùng `z.coerce.boolean()` cho tham số URL.** Nó gọi thẳng `Boolean(v)`,
 * mà `Boolean('false') === true` — nên `?asc=false` và `?asc=true` cho ra CÙNG một
 * kết quả. Không có lỗi nào được ném ra; bộ lọc chỉ đơn giản là không hoạt động.
 *
 * Đã xảy ra thật, hai lần, và lần nào cũng chỉ lộ ra khi đo trên bản đang chạy:
 *
 *  - `RegistryQuery.asc` (spec SC-13, chạy thật từ 10/08): giao diện gửi
 *    `asc=false` khi người dùng bấm sắp xếp giảm dần → máy chủ hiểu thành `true`,
 *    nên **nút sắp xếp giảm dần chưa từng hoạt động**. Bảng vẫn hiện dữ liệu đúng,
 *    chỉ là sai thứ tự — không ai để ý.
 *  - `ChangeFeedQuery.onlySerious` (spec SC-19): tab "Tất cả" gửi
 *    `onlySerious=false` → máy chủ lọc như "Chỉ nghiêm trọng", nên danh sách trống
 *    trong khi thay đổi có thật. Đúng kiểu hiểu nhầm mà SC-19 §4 Y6 đang cố tránh.
 *
 * Ở đây chỉ đúng ba chuỗi được coi là bật; mọi thứ khác là tắt. Không ném lỗi vì
 * một tham số gõ sai trên thanh địa chỉ không nên làm hỏng cả màn hình.
 */
exports.QueryBooleanSchema = zod_1.z.preprocess((v) => {
    if (typeof v === 'boolean')
        return v;
    if (typeof v === 'string')
        return ['true', '1', 'yes'].includes(v.trim().toLowerCase());
    return v;
}, zod_1.z.boolean());
//# sourceMappingURL=query.js.map